import React, { createContext, useContext, useState, ReactNode } from "react";

interface CardDetailsContextValue {
  hasAddedCard: boolean;
  setHasAddedCard: React.Dispatch<React.SetStateAction<boolean>>;
}

// default no-op setter to avoid undefined checks when used outside provider (dev only).
const CardDetailsContext = createContext<CardDetailsContextValue>({
  hasAddedCard: false,
  // eslint-disable-next-line @typescript-eslint/no-empty-function
  setHasAddedCard: () => {},
});

export const CardDetailsProvider: React.FC<{ children: ReactNode }> = ({ children }) => {
  const [hasAddedCard, setHasAddedCard] = useState<boolean>(false);

  return (
    <CardDetailsContext.Provider value={{ hasAddedCard, setHasAddedCard }}>
      {children}
    </CardDetailsContext.Provider>
  );
};

export const useCardDetails = () => useContext(CardDetailsContext); 